import React from "react";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import StraightenOutlinedIcon from "@mui/icons-material/StraightenOutlined";
import { Box, Typography } from "@mui/material";
import { useScreenshotTranslation } from "../../../lib/screenshotI18n";
import {
    screenshotMetaDividerSx,
    screenshotMetaHalfSx,
    screenshotMetaIconSx,
    screenshotMetaLabelSx,
    screenshotMetaRegionOverlaySx,
    screenshotMetaRegionSx,
    screenshotMetaShellOnDarkSx,
    screenshotMetaShellSx,
    screenshotMetaValueSx,
} from "../styles/screenshotStyles";

/**
 * Bottom marketing strip — puzzle size and difficulty (App Store screenshot).
 */
export default function ScreenshotSizeDifficultyBar({
    gridSize,
    difficultyLevel,
    onDark = false,
    sizeAsGrid = false,
    difficultyText = null,
    embedded = false,
}) {
    const { t } = useScreenshotTranslation();
    const grid = Number(gridSize);
    const levelKey = String(difficultyLevel ?? "MEDIUM").toLowerCase();
    const difficultyLabel = difficultyText || t(`puzzle.card.difficulty-${levelKey}`);
    const sizeLabelKey = sizeAsGrid
        ? "puzzle.sliding.meta-grid-label"
        : "puzzle.sliding.meta-size-label";

    if (!Number.isFinite(grid) || grid <= 0) return null;

    const regionSx = embedded
        ? {
              flex: "0 0 auto",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 4,
              px: 1,
              py: 0.85,
              bgcolor: "#0b1220",
          }
        : onDark
          ? screenshotMetaRegionOverlaySx
          : screenshotMetaRegionSx;

    return (
        <Box sx={regionSx}>
            <Box sx={onDark || embedded ? screenshotMetaShellOnDarkSx : screenshotMetaShellSx}>
                <Box sx={screenshotMetaHalfSx}>
                    <StraightenOutlinedIcon sx={screenshotMetaIconSx} aria-hidden />
                    <Box>
                        <Typography component="p" sx={screenshotMetaLabelSx}>
                            {t(sizeLabelKey)}
                        </Typography>
                        <Typography component="p" sx={screenshotMetaValueSx}>
                            {sizeAsGrid ? `${grid}x${grid}` : `${grid} × ${grid}`}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={screenshotMetaDividerSx} aria-hidden />

                <Box sx={screenshotMetaHalfSx}>
                    <ShieldOutlinedIcon sx={screenshotMetaIconSx} aria-hidden />
                    <Box>
                        <Typography component="p" sx={screenshotMetaLabelSx}>
                            {t("puzzle.sliding.meta-difficulty-label")}
                        </Typography>
                        <Typography component="p" sx={screenshotMetaValueSx}>
                            {difficultyLabel}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
